import styled from 'styled-components';

export const PasswordFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
